module.exports = __webpack_public_path__ + "static/media/image.93776d79.png";